export default {
	generic: 'Hiba történt. 🙁',
	refresh: 'Kattints ide az oldal újratöltéséhez!',
	pageNotFound: 'Az oldal nem található.',
	back: 'Vissza a főoldalra',
};
